import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { GlobalState } from "../store";
import { sessionLocalStorageKey } from "@/global/config/constants";
import { UserType } from "./types";

export const userState = createSlice({
  name: "user",
  initialState: null as unknown as UserType,
  reducers: {
    set: (
      state,
      action: PayloadAction<{ teamSchema: string; session: UserType }>
    ) => {
      const session = action?.payload.session;
      const teamSchema = action.payload.teamSchema;
      const storageKey = sessionLocalStorageKey + "-" + teamSchema;
      try {
        const stringfiedUser = JSON.stringify(session);
        window.localStorage.setItem(storageKey, stringfiedUser);
      } catch (err) {
        console.log(err);
      }
      return { ...session };
    },
    remove: (_, action: PayloadAction<{ teamSchema: string }>) => {
      const teamSchema = action.payload.teamSchema;
      const storageKey = sessionLocalStorageKey + "-" + teamSchema;
      try {
        window.localStorage.removeItem(storageKey);
      } catch (err) {
        console.log(err);
      }
      return null as any;
    },
    check: (_, action: PayloadAction<{ teamSchema: string }>) => {
      const teamSchema = action.payload.teamSchema;
      const storageKey = sessionLocalStorageKey + "-" + teamSchema;
      try {
        const user = JSON.parse(
          window.localStorage.getItem(storageKey) as string
        );
        return user;
      } catch (err) {
        console.log(err);
      }
    },
  },
});

export const selectUser = createSelector(
  (s: GlobalState) => s,
  (s) => s.user
);

export default userState.reducer;
